/* eslint-disable no-else-return */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import cx from 'classnames';
import { translate } from 'react-i18next';

import DurationPlot from './Plots/DurationPlot';
import DistancePlot from './Plots/DistancePlot';
import CostPlot from './Plots/CostPlot';
import ExpensesPlot from './Plots/ExpensesPlot';

import { changeCurrentRange } from './actions';

const TABS = ['timeTab', 'distanceTab', 'costTab', 'expensesTab'];

@translate(['dashboard'], { wait: true })
class Graph extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentTabIndex: 0,
      currentRange: [moment().subtract(29, 'days'), moment()],
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleEvent = this.handleEvent.bind(this);
  }

  handleEvent(event, picker) {
    event.preventDefault();
    this.props.changeRange([picker.startDate, picker.endDate]);
  }

  handleTabChange(e) {
    e.preventDefault();
    e.stopPropagation();
    const id = e.target.href.split('#').pop();

    this.setState({
      currentTabIndex: TABS.indexOf(id),
    });
  }

  render() {
    const { t } = this.props;
    const timeClass = cx({
      active: this.state.currentTabIndex === 0,
    });
    const distanceClass = cx({
      active: this.state.currentTabIndex === 1,
    });
    const costClass = cx({
      active: this.state.currentTabIndex === 2,
    });
    const expensesClass = cx({
      active: this.state.currentTabIndex === 3,
    });

    return (
      <div
        className="graph-section"
        style={{ maxWidth: 1200, margin: '0 auto' }}
      >
        <div className="container">
          <div className="graph-section__tabSet">
            <div className={`tabSet ${timeClass}`}>
              <a onClick={this.handleTabChange} href="#timeTab">
                {t('dashboard:timeTab')}
              </a>
            </div>
            <div className={`tabSet ${distanceClass}`}>
              <a onClick={this.handleTabChange} href="#distanceTab">
                {t('dashboard:distanceTab')}
              </a>
            </div>
            <div className={`tabSet ${expensesClass}`}>
              <a onClick={this.handleTabChange} href="#expensesTab">
                {t('dashboard:expensesTab')}
              </a>
            </div>
          </div>
          <div className="graph-section__tabWrap">
            {this.state.currentTabIndex === 0 && (
              <DurationPlot
                range={this.props.currentRange}
                handleEvent={this.handleEvent}
              />
            )}
            {this.state.currentTabIndex === 1 && (
              <DistancePlot
                range={this.props.currentRange}
                handleEvent={this.handleEvent}
              />
            )}
            {this.state.currentTabIndex === 3 && (
              <ExpensesPlot
                range={this.props.currentRange}
                handleEvent={this.handleEvent}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

Graph.WrappedComponent.propTypes = {
  changeRange: PropTypes.func.isRequired,
  currentRange: PropTypes.arrayOf(PropTypes.instanceOf(moment)).isRequired,
  currentLanguage: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    currentRange: state.dashboard.filteredReports.currentRange,
    currentLanguage: state.langs.currentLanguage,
  }),
  dispatch => ({
    changeRange(range) {
      const [From, UpTo] = range;
      return dispatch(
        changeCurrentRange({
          From,
          UpTo,
        }),
      );
    },
  }),
)(Graph);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Graph.js